

import React, { useState } from "react";


import Foodsetingspage from './Foodsetingspage';
import Cateringsetiingspage from '../Catering/Cateringsetiingspage';
import Teamlanding from './Teamlanding';
import PromotionBilling from "./PromotionBilling";
import DeliveryBillingcharges from "./DeliveryBillingcharges";
/* ---------- Dummy Section Component ---------- */


/* ---------- Main Company Component ---------- */
const Company = () => {
  const tabs = [
    { id: 1, name: "FOOD& BEVERAGES", component: () => <Foodsetingspage title="FOOD& BEVERAGES" /> },
    { id: 2, name: "Cartering", component: () => <Cateringsetiingspage title="Company Structure" /> },
    { id: 3, name: "Promotions", component: () => <PromotionBilling title="Company Structure" /> },
    { id: 4, name: "Delivery", component: () => <DeliveryBillingcharges title="Company Structure" /> },
    // { id: 3, name: "Teams", component: () => <Teamlanding title="Company Structure" /> },


  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="company-container">

      {/* 🔹 Inline CSS */}
      <style>{`
   /* Default (Mobile first) – kuch change nahi */
   .company-scroll-container {
     position: static;
     background: #fff;
   }
 
   .company-buttons-row {
     display: flex;
     // gap: 10px;
     flex-wrap: wrap;
   }
 
   .company-button {
     padding: 8px 16px;
     border: none;
     background: #f0f0f0;
     cursor: pointer;
     border-radius: 6px;
     white-space: nowrap;
   }
 
   .company-button.active {
     background: #e66d33;
     color: #fff;
   }
 
   /* ✅ Desktop / Laptop only */
   @media (min-width: 769px) {
     .company-scroll-container {
       position: sticky;
       top: 0;
       z-index: 100;
       padding: 10px 0;
     }
   }
 `}</style>


      {/* Tabs */}
      <div className="company-scroll-container">
        <div className="company-buttons-row">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`company-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      {/* Active Section */}
      <div className="component-display">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};


export default Company; 